import { useSelector } from 'react-redux';
export default function useSelectorOrDefault(selector, def, equalityFn) {
    const selected = useSelector(selector, equalityFn);
    return selected || def;
}
